export const COLLECT_PUBLIC_CREDENTIAL = 'collect_public_credential';
